import { useEffect } from 'react';

import { useAppSelector, useAppDispatch } from 'redux/store';

import { getQueuesPaginated } from '../../../../../../../redux/slices/lists/queuesSlice';
import { LoadingSelect } from 'components/forms/LoadingFields';

const Queues = ({
  selectedValue,
  defaultValue = null,
  onChange,
}: {
  selectedValue: string | null | undefined;
  defaultValue?: string | null;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}) => {
  const dispatch = useAppDispatch();

  const { queues = [], loading } = useAppSelector((state) => state.listOfQueues);

  const isLoading = !!loading?.getQueuesPaginated;

  useEffect(() => {
    const fetchData = async () => {
      if (queues.length) return;

      try {
        dispatch(getQueuesPaginated({ page: 1, limit: 2000 }));
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, [dispatch, queues.length]);

  const splitDefaultValue = defaultValue ? defaultValue.split('|') : '';
  const formattedDefaultValue = `${splitDefaultValue[1]} (${splitDefaultValue[0]})`;
  const defaultText = defaultValue ? `Default: ${formattedDefaultValue}` : '-- (null)';

  const newQueues = queues.filter((queue) => {
    const { queue_name, zone_name } = queue;
    const isDefaultQueue = queue_name === splitDefaultValue[1] && zone_name === splitDefaultValue[0];
    if (!isDefaultQueue) return queue;
  });

  const options = [
    {
      value: '',
      label: defaultText,
    },
    ...newQueues.map((queue, index) => {
      const { queue_name, zone_name } = queue;

      return {
        value: `${zone_name}|${queue_name}`,
        label: `${queue_name} (${zone_name})`,
      };
    }),
  ];

  return (
    <LoadingSelect
      label="Default Queue"
      name="default_queue_path"
      value={selectedValue || defaultValue || ''}
      onChange={onChange}
      isLoading={isLoading}
      controlId="formProperties"
      options={options}
    />
  );
};

export default Queues;
